/* eslint no-confusing-arrow: 0 */
import * as types from 'constants/ActionTypes';
import { listWM, list, save, create, custom } from 'utils/Api';
import {
  map, omit, forEach, keyBy, find, replace,
  startsWith, endsWith, includes, isEmpty,
} from 'lodash';

export const requestAgreements = () => ({
  type: types.REQUEST_AGREEMENTS,
});

export const requestAgreementsFailure = error => ({
  type: types.REQUEST_AGREEMENTS_FAILURE,
  error,
});

export const requestAgreementsSuccess = ({
  agreements, edID, label, answers,
}) => ({
  type: types.REQUEST_AGREEMENTS_SUCCESS,
  newAgreements: {
    [edID]: {
      label,
      agreements,
      answers: keyBy(answers, 'AgreementID'),
    },
  },
});

export const fetchAgreements = () =>
  (dispatch, getState) => {
    dispatch(requestAgreements());
    const now = new Date().toISOString();
    const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();
    const detailConfig = {
      entity: 'EmployeeDetailOrg',
      headers: { Authorization: `Bearer ${token}` },
      params: {
        $filter: `Entity/EmployeeDetailID ge ${EmployeeMasterID}1 and Entity/EmployeeDetailID le ${EmployeeMasterID}9 and (Entity/EmployeeStatus eq '0' or (Entity/EmployeeStatus ge '4'  and Entity/EmployeeStatus le '7')) and Entity/Begda le datetime'${now}' and Entity/Endda ge datetime'${now}'`,
        $expand: 'Entity',
        $select: 'OrgCompanyPositionName,Entity/EmployeeDetailID,Entity/EmployeeGroup,Entity/EmployeeStatus',
      },
    };
    const agreementConfig = {
      entity: 'HrAgreement',
      headers: { Authorization: `Bearer ${token}` },
    };

    const answerConfig = {
      entity: 'EmployeeDetailAgreement',
      headers: { Authorization: `Bearer ${token}` },
    };

    listWM(detailConfig)
      .then((details) => {
        const pos = map(details.data, x => ({ label: x.OrgCompanyPositionName, ...x.Entity }));
        if (isEmpty(pos)) throw new Error('Missing EmployeeDetailOrg');
        forEach(pos, (p) => {
          list({
            ...agreementConfig,
            params: {
              $filter: `Active eq true and (EmployeeStatus eq '${p.EmployeeStatus}' or EmployeeStatus eq '0') and (EmployeeGroup eq '${p.EmployeeGroup}' or EmployeeGroup eq '0')`,
            },
          })
            .then((agreements) => {
              const agreementIDs = map(agreements.data, x => x.HrAgreementID);

              if (!agreementIDs.length) {
                return dispatch(requestAgreementsSuccess({
                  edID: p.EmployeeDetailID,
                  agreements: agreements.data,
                  answers: [],
                  label: p.label,
                }));
              }

              return list({
                ...answerConfig,
                params: {
                  $filter: `(${map(agreementIDs, id => `AgreementID eq ${id}`).join` or `}) and Endda eq DateTime'9999-12-31T00:00:00' and EmployeeDetailID eq ${p.EmployeeDetailID}`,
                },
              })
                .then(answers => dispatch(requestAgreementsSuccess({
                  edID: p.EmployeeDetailID,
                  agreements: agreements.data,
                  answers: answers.data,
                  label: p.label,
                }))).catch(err => dispatch(requestAgreementsFailure(err)));
            }).catch(err => dispatch(requestAgreementsFailure(err)));
        });
      }).catch(err => dispatch(requestAgreementsFailure(err)));
  };

export const requestAgreementYes = () => ({
  type: types.REQUEST_AGREEMENT_YES,
});

export const requestAgreementNo = () => ({
  type: types.REQUEST_AGREEMENT_NO,
});

export const updateAnswers = newAnswer => ({
  type: types.UPDATE_AGREEMENT_ANSWERS,
  newAnswer,
});

const cleanEntity = e => omit(e, ['CreateDate', 'CreateUserID', 'ModifyDate', 'ModifyUserID', 'RowVersion', 'KeyID', 'UniqueID', 'EntityID']);

const checkAndUpload = ({ file, fileType }, cb) =>
  (dispatch, getState) => {
    /** If there is a file we need to start by uploading
     * it so we can connect it with the answer.
     */
    const { loginReducer: { user: { token, EmployeeMasterID } } } = getState();
    if (file && fileType) {
      const reader = new FileReader();
      reader.onload = () => {
        const FileSource = reader.result.substring(reader.result.indexOf(',') + 1);
        const Name = file.name.substring(0, file.name.indexOf('.'));
        const Extension = file.name.substring(file.name.indexOf('.'));
        const AddDate = new Date().toISOString();
        const config = {
          entity: 'FileRepository',
          headers: { Authorization: `Bearer ${token}` },
          data: {
            AddDate,
            EntityType: 2,
            Entity_ID: EmployeeMasterID,
            FileSource,
            ObjectDocumentType: fileType,
            Name,
            Extension,
          },
        };

        return create(config)
          .then((createResult) => {
            cb(createResult.data);
          })
          .catch(error => dispatch(requestAgreementsFailure(error)));
      };
      reader.onerror = e => dispatch(requestAgreementsFailure(e));
      reader.readAsDataURL(file);
    } else {
      cb(0);
    }
  };

const updateSpecialEntity = (entityInfo, fields, EmployeeDetailID, cb) =>
  (dispatch, getState) => {
    /** Will not allow changing of entities outside of Employee NS */
    if (entityInfo.entity.indexOf('Employee') !== 0) {
      return cb();
    }
    const { loginReducer: { user: { token, EmployeeMasterID } } } = getState();
    const now = new Date().toISOString();

    /** Fetch and check if there is a special entity for the user */
    /** Check if the entity is employee master or detail based */
    const existingConfig = {
      headers: { Authorization: `Bearer ${token}` },
      entity: entityInfo.entity,
    };
    if (startsWith(entityInfo.entity, 'EmployeeMaster')) {
      existingConfig.params = {
        $filter: entityInfo.fields.length ?
          // `${map(entityInfo.fields, f => `${f[0]} eq ${f[1]}`).join` and `} and EmployeeMasterID eq ${EmployeeMasterID} and Endda ge DateTime'${now}' and Begda le DateTime'${now}'` :
          `${map(entityInfo.fields, f => endsWith(f[0], 'ID') ? `${f[0]} eq ${f[1]}` : `${f[0]} eq ${f[1]}`).join` and `} and EmployeeMasterID eq ${EmployeeMasterID} and Endda ge DateTime'${now}' and Begda le DateTime'${now}'` :
          // `${map(entityInfo.fields, f => (endsWith(f[0], 'ID') || endsWith(f[0], 'Type')) ? `${f[0]} eq '${f[1]}'` : `${f[0]} eq ${f[1]}`).join` and `} and EmployeeDetailID eq ${EmployeeDetailID} and Endda ge DateTime'${now}' and Begda le DateTime'${now}'` :
          `EmployeeDetailID eq ${EmployeeDetailID} and Endda ge DateTime'${now}' and Begda le DateTime'${now}'`,
      };
    } else {
      existingConfig.params = {
        $filter: entityInfo.fields.length ?
          // `${map(entityInfo.fields, f => `${f[0]} eq ${f[1]}`).join` and `} and EmployeeDetailID eq ${EmployeeDetailID} and Endda ge DateTime'${now}' and Begda le DateTime'${now}'` :
          `${map(entityInfo.fields, f => endsWith(f[0], 'ID') ? `${f[0]} eq '${f[1]}'` : `${f[0]} eq ${f[1]}`).join` and `} and EmployeeDetailID eq ${EmployeeDetailID} and Endda ge DateTime'${now}' and Begda le DateTime'${now}'` :
          // `${map(entityInfo.fields, f => (endsWith(f[0], 'ID') || endsWith(f[0], 'Type')) ? `${f[0]} eq '${f[1]}'` : `${f[0]} eq ${f[1]}`).join` and `} and EmployeeDetailID eq ${EmployeeDetailID} and Endda ge DateTime'${now}' and Begda le DateTime'${now}'` :
          `EmployeeDetailID eq ${EmployeeDetailID} and Endda ge DateTime'${now}' and Begda le DateTime'${now}'`,
      };
    }


    return list(existingConfig)
      .then((existing) => {
        if (existing.data.length) {
          const oldEntity = cleanEntity(existing.data[0]);
          const configUpdate = {
            headers: { Authorization: `Bearer ${token}` },
            entity: entityInfo.entity,
            data: {
              ...oldEntity,
              ...fields,
            },
          };

          return save(configUpdate)
            .then(cb);
        }
        /** Return here if there were no entries to update. */
        return cb();
      });
  };

export const handleAgreement = (AgreementID, EmployeeDetailID, file, UploadType) =>
  (dispatch, getState) => {
    const {
      loginReducer: { user: { token, EmployeeMasterID } },
      AgreementsReducer: { agreementsByID },
    } = getState();
    const headers = { Authorization: `Bearer ${token}` };
    const agreementInfo = agreementsByID[EmployeeDetailID];
    const agreement = agreementInfo && find(agreementInfo.agreements, ['HrAgreementID', AgreementID]);
    if (!agreementInfo || !agreement) {
      return dispatch(requestAgreementsFailure({ Message: 'Error in agreements, no info' }));
    }

    return dispatch(checkAndUpload({ file, fileType: UploadType }, (Document) => {
      /** Check if there is already an answer to the agreement that is YES */
      const now = new Date().toISOString();

      const newAnswer = (agreementInfo.answers &&
        agreementInfo.answers[AgreementID] &&
        agreementInfo.answers[AgreementID].EmployeeDetailAgreementAnswer === 1) ? 0 : 1;

      if (agreementInfo.answers &&
        agreementInfo.answers[AgreementID]
      ) {
        const existingAnswer = agreementInfo.answers[AgreementID];

        const configUpdateOld = {
          headers,
          entity: 'EmployeeDetailAgreement',
          data: {
            ...cleanEntity(existingAnswer),
            EmployeeDetailEndda: now,
            Endda: now,
          },
        };
        /** First we need to outdate the old answer */
        save(configUpdateOld)
          .catch(err => requestAgreementsFailure(err));
      }
      /** Check if there is a special entity we need to update */
      if (agreement.HrAgreementEntity && agreement.HrAgreementValue && (includes(agreement.HrAgreementValue, 'ID') || includes(agreement.HrAgreementValue, 'Type'))) {
        /** We check for older entities and outdate them */
        const entity = agreement.HrAgreementEntity;
        const fields = map(replace(agreement.HrAgreementValue, ' ', '').split`,`, x => x.split`:`);
        const newFields = { Endda: now };
        dispatch(updateSpecialEntity({ entity, fields }, newFields, EmployeeDetailID, () => {
          /** Done updating the entity */
          /** Create a new special entity if we are agreeing */
          if (newAnswer === 1) {
            const specialFields = {};
            fields.forEach((x) => { specialFields[x[0]] = x[1]; });
            const configEntity = {
              headers,
              entity,
              data: {
                Begda: agreement.HrAgreementBegda || now,
                Endda: agreement.HrAgreementEndda || '9999-12-31T00:00:00',
                ...specialFields,
              },
            };
            if (startsWith(entity, 'EmployeeMaster')) {
              configEntity.data.EmployeeMasterID = EmployeeMasterID;
            } else {
              configEntity.data.EmployeeDetailID = EmployeeDetailID;
            }
            create(configEntity)
              .catch(err => requestAgreementsFailure(err));
          }
        }));
      }

      const configNewAnswer = {
        headers,
        entity: 'EmployeeDetailAgreement',
        data: {
          EmployeeDetailID,
          EmployeeMasterID,
          EmployeeDetailAgreementAnswer: newAnswer,
          AgreementID,
          DocumentID: Document.DocumentId,
          Begda: now,
          Endda: '9999-12-31T00:00:00',
        },
      };

      /** Add the new answer */
      create(configNewAnswer)
        .then((res) => {
          dispatch(fetchAgreements());
          const configMail = {
            headers,
            method: 'POST',
            url: '/api/EmployeeDetailAgreementEmail/SendEmailNotification',
            data: {
              ...cleanEntity(res.data),
            },
          };
          custom(configMail);
        });

      return newAnswer === 1 ? dispatch(requestAgreementYes()) : dispatch(requestAgreementNo());
    }));
  };



// WEBPACK FOOTER //
// ./src/actions/Agreements.js